import React, { useEffect } from 'react';
import { useGameContext } from '../GameContext';

const GameSetup: React.FC = () => {
  const { 
    startGame, 
    isGameActive, 
    resetGame,
    loadingDailyLevels,
    dailyLevelsError
  } = useGameContext();

  const handleStartGame = () => {
    startGame();
  };
  
  // Add event listener for Enter key to start the game
  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      // Only proceed if not active and not loading
      if (event.key === 'Enter' && !isGameActive && !loadingDailyLevels) {
        event.preventDefault(); // Prevent default behavior
        event.stopPropagation(); // Stop propagation to other handlers
        startGame();
      }
    };

    // Remove the event listener when the component unmounts or when isGameActive changes
    window.addEventListener('keydown', handleKeyPress, true);
    
    return () => {
      window.removeEventListener('keydown', handleKeyPress, true);
    };
  }, [startGame, isGameActive, loadingDailyLevels]);
  
  // Cleanup the event listener when game becomes active
  useEffect(() => {
    // When game becomes active, we don't need this listener anymore
    if (isGameActive) {
      const noop = () => {}; // Empty function for type safety
      window.removeEventListener('keydown', noop, true);
    }
  }, [isGameActive]);

  if (isGameActive) {
    return (
      <div className="game-controls">
        <button onClick={resetGame} className="reset-button">
          Reset Game
        </button>
      </div>
    );
  }

  if (loadingDailyLevels) {
    return (
      <div className="game-setup loading">
        <p className="loading-message">
          Fetching headlines that'll make you say "NO WAY LOL"...
          <span className="loading-spinner-inline"></span>
        </p>
      </div>
    );
  }

  return (
    <div className="game-setup">
      <p className="game-tagline">
        Headlines that'll make you say "NO WAY LOL"
      </p>
      
      {dailyLevelsError && (
        <div className="error-message">
          {dailyLevelsError}
        </div>
      )}
      
      <div className="start-options">
        <button onClick={handleStartGame} className="game-action-button">
          START
        </button>
      </div>
      
    </div>
  );
};

export default GameSetup;